module.exports = __webpack_public_path__ + "fonts/Barlow-Medium.34274f1.woff2";